import { styled } from "@mui/material";

export const SubFormContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
    paddingBottom: 0,
    border: 'solid 3px',
    borderColor: theme.palette.primary.main,
    borderRadius: 8,
}));
